export default "__VITE_ASSET__CpzgPI5e__"